import type { JSX } from "react";

import { ContextMenu as BaseContextMenu } from "@base-ui/react/context-menu";

import type { ContextMenuTriggerProps } from "./ContextMenu.types";

export function ContextMenuTrigger({
  ...props
}: ContextMenuTriggerProps): JSX.Element {
  return (
    <BaseContextMenu.Trigger data-slot="context-menu-trigger" {...props} />
  );
}
